
export const ActionTypes = {
	SET_STATE: 'SET_STATE', 

	UI_OFFCANVAS_TOGGLE: 'UI_OFFCANVAS_TOGGLE',
	UI_OFFCANVAS_SHOW: 'UI_OFFCANVAS_SHOW',
	UI_OFFCANVAS_HIDE: 'UI_OFFCANVAS_HIDE',
	UI_SEARCH_TOGGLE: 'UI_SEARCH_TOGGLE',
	UI_SEARCH_SHOW: 'UI_SEARCH_SHOW',
	UI_SEARCH_HIDE: 'UI_SEARCH_HIDE',
	UI_SET_ACTIVE_MODAL: 'UI_SET_ACTIVE_MODAL',
	UI_FIX_SCROLLBAR: 'UI_FIX_SCROLLBAR',
	UI_UNFIX_SCROLLBAR: 'UI_UNFIX_SCROLLBAR',

	ADD_ITEM_TO_CART: 'ADD_ITEM_TO_CART',
	REMOVE_ITEM_FROM_CART: 'REMOVE_ITEM_FROM_CART',
	SET_ITEM_QUANTITY_IN_CART: 'SET_ITEM_QUANTITY_IN_CART', 

	ADD_ITEM_TO_WISHLIST: 'ADD_ITEM_TO_WISHLIST',
	REMOVE_ITEM_FROM_WISHLIST: 'REMOVE_ITEM_FROM_WISHLIST',

	ADD_ITEM_TO_COMPARE: 'ADD_ITEM_TO_COMPARE',
	REMOVE_ITEM_FROM_COMPARE: 'REMOVE_ITEM_FROM_COMPARE',

	SET_LOCATION: 'SET_LOCATION',
	CONFIRM_LOCATION: 'CONFIRM_LOCATION'
};

export const ActionCreators = {
	setState(newState)
	{
		return {
			type: ActionTypes.SET_STATE,
			newState
		};
	},

	uiOffCanvasToggle()
	{
		return { type: ActionTypes.UI_OFFCANVAS_TOGGLE }
	},

	uiOffCanvasShow()
	{
		return { type: ActionTypes.UI_OFFCANVAS_SHOW }
	},

	uiOffCanvasHide()
	{
		return { type: ActionTypes.UI_OFFCANVAS_HIDE }
	},

	uiSearchToggle()
	{
		return { type: ActionTypes.UI_SEARCH_TOGGLE }
	},

	uiSearchShow()
	{
		return { type: ActionTypes.UI_SEARCH_SHOW }
	},

	uiSearchHide()
	{
		return { type: ActionTypes.UI_SEARCH_HIDE }
	},

	uiSetActiveModal(id = null)
	{
		return { type: ActionTypes.UI_SET_ACTIVE_MODAL, id }
	},

	uiFixScrollbar()
	{
		return { type: ActionTypes.UI_FIX_SCROLLBAR }
	},

	uiUnfixScrollbar()
	{
		return { type: ActionTypes.UI_UNFIX_SCROLLBAR }
	},

	addItemToCart(itemId, quantity = 1)
	{
		return {
			type: ActionTypes.ADD_ITEM_TO_CART,
			itemId,
			quantity
		};
	},

	removeItemFromCart(itemId)
	{
		return {
			type: ActionTypes.REMOVE_ITEM_FROM_CART,
			itemId,
		}
	},

	setItemQuantityInCart(itemId, quantity)
	{
		return {
			type: ActionTypes.SET_ITEM_QUANTITY_IN_CART,
			itemId,
			quantity
		}
	},

	addItemToWishlist(itemId)
	{
		return {
			type: ActionTypes.ADD_ITEM_TO_WISHLIST,
			itemId
		}
	},

	removeItemFromWishlist(itemId)
	{
		return {
			type: ActionTypes.REMOVE_ITEM_FROM_WISHLIST,
			itemId
		}
	},

	addItemToCompare(itemId)
	{
		return {
			type: ActionTypes.ADD_ITEM_TO_COMPARE,
			itemId
		}
	},

	removeItemFromCompare(itemId)
	{
		return {
			type: ActionTypes.REMOVE_ITEM_FROM_COMPARE,
			itemId
		}
	},

	setLocation(locationId)
	{
		return {
			type: ActionTypes.SET_LOCATION,
			locationId
		}
	},

	confirmLocation()
	{
		return {
			type: ActionTypes.CONFIRM_LOCATION
		}
	}
};

